import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

export default function AboutAccordion() {
  const { t } = useTranslation();
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const ABOUT_ITEMS = [
    {
      title: t('about_what_title'), icon: '🏥',
      paragraphs: [t('about_what_p1'), t('about_what_p2')],
    },
    {
      title: t('about_mission_title'), icon: '🎯',
      paragraphs: [t('about_mission_p1')],
      bullets: [
        { label: t('about_mission_b1_l'), text: t('about_mission_b1_t') },
        { label: t('about_mission_b2_l'), text: t('about_mission_b2_t') },
        { label: t('about_mission_b3_l'), text: t('about_mission_b3_t') },
        { label: t('about_mission_b4_l'), text: t('about_mission_b4_t') },
      ],
    },
    {
      title: t('about_history_title'), icon: '📜',
      paragraphs: [
        t('about_history_p1'),
      ],
      bullets: [
        { label: t('about_history_b1_l'), text: t('about_history_b1_t') },
        { label: t('about_history_b2_l'), text: t('about_history_b2_t') },
        { label: t('about_history_b3_l'), text: t('about_history_b3_t') },
        { label: t('about_history_b4_l'), text: t('about_history_b4_t') },
        { label: t('about_history_b5_l'), text: t('about_history_b5_t') },
      ],
      trailingParagraphs: [
        t('about_history_p2'),
        t('about_history_p3'),
        t('about_history_p4'),
        t('about_history_p5'),
        t('about_history_p6'),
      ],
    },
    {
      title: t('about_structure_title'), icon: '🏛️',
      paragraphs: [t('about_structure_p1')],
      bullets: [
        { label: t('about_structure_b1_l'), text: t('about_structure_b1_t') },
        { label: t('about_structure_b2_l'), text: t('about_structure_b2_t') },
        { label: t('about_structure_b3_l'), text: t('about_structure_b3_t') },
      ],
    },
    {
      title: t('about_leadership_title'), icon: '👥',
      paragraphs: [t('about_leadership_p1')],
      bullets: [
        { label: t('about_leadership_b1_l'), text: t('about_leadership_b1_t') },
        { label: t('about_leadership_b2_l'), text: t('about_leadership_b2_t') },
        { label: t('about_leadership_b3_l'), text: t('about_leadership_b3_t') },
      ],
    },
  ];

  return (
    <section className="section" style={{ background: '#fff' }}>
      <div style={{ marginBottom: 48 }}>
        <span className="section-label">{t('about_label')}</span>
        <h2 className="section-title">{t('about_title')}</h2>
        <p className="section-subtitle">{t('about_subtitle')}</p>
      </div>

      <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
        {ABOUT_ITEMS.map((item, i) => (
          <div key={i} style={{
            background: '#f8faff', borderRadius: 12,
            border: '1px solid #e2e8f0', overflow: 'hidden',
            boxShadow: openIndex === i ? '0 4px 20px rgba(26,58,107,0.1)' : 'none',
          }}>
            <div onClick={() => setOpenIndex(openIndex === i ? null : i)} style={{
              display: 'flex', alignItems: 'center', justifyContent: 'space-between',
              padding: '18px 24px', cursor: 'pointer',
              background: openIndex === i ? '#1a3a6b' : 'transparent',
              transition: 'background 0.2s',
            }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: 14 }}>
                <span style={{ fontSize: '1.4rem' }}>{item.icon}</span>
                <span style={{ fontWeight: 700, fontSize: '1rem', color: openIndex === i ? '#fff' : '#1a2a4a' }}>
                  {item.title}
                </span>
              </div>
              <span style={{
                fontSize: '0.85rem', fontWeight: 700,
                color: openIndex === i ? '#fff' : '#1a3a6b',
                display: 'inline-block',
                transform: openIndex === i ? 'rotate(180deg)' : 'none',
                transition: 'transform 0.3s',
              }}>▼</span>
            </div>

            <div style={{ maxHeight: openIndex === i ? 8000 : 0, overflow: 'hidden', transition: 'max-height 0.5s ease' }}>
              <div style={{ padding: '20px 24px', borderTop: '1px solid #e2e8f0' }}>
                {item.paragraphs.map((p, j) => (
                  <p key={j} style={{ color: '#444', lineHeight: 1.7, marginBottom: 10 }}>{p}</p>
                ))}
                {item.bullets && (
                  <ul style={{ marginTop: 8, paddingLeft: 0, listStyle: 'none', display: 'flex', flexDirection: 'column', gap: 8 }}>
                    {item.bullets.map((b, j) => (
                      <li key={j} style={{ display: 'flex', gap: 10, alignItems: 'flex-start' }}>
                        <span style={{ minWidth: 8, height: 8, borderRadius: '50%', background: '#1a3a6b', marginTop: 7, flexShrink: 0 }} />
                        <span style={{ fontSize: '0.93rem', color: '#374151' }}>
                          <strong style={{ color: '#1a3a6b' }}>{b.label}:</strong>{' '}
                          <span style={{ color: '#6b7280' }}>{b.text}</span>
                        </span>
                      </li>
                    ))}
                  </ul>
                )}
                {item.trailingParagraphs && item.trailingParagraphs.map((p, j) => (
                  <p key={`tp-${j}`} style={{ color: '#444', lineHeight: 1.7, marginTop: item.bullets ? 14 : 0, marginBottom: 10 }}>{p}</p>
                ))}
              </div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
